import { Component } from "@angular/core";
import { Options } from "@angular-slider/ngx-slider";

import {
  HsLayerManagerService,
  HsEventBusService,
  HsLayerUtilsService,
  HsLanguageService,
  setExclusive,
  HsLayerDescriptor,
} from "hslayers-ng";

import { AppService } from "../../app.service";
import { Layer } from "ol/layer";
import { Source } from "ol/source";
import { __metadata } from "tslib";

@Component({
  selector: "ac-layermanager",
  templateUrl: "./layermanager.component.html",
  styleUrls: ["./layermanager.component.scss"],
})
export class LayermanagerComponent {
  layers: HsLayerDescriptor[] = [];
  layerEditorVisible = false;
  visibleLayer: any = { title: "Selected layer" };
  opacitySliderOptions: Options = {
    floor: 0,
    ceil: 1,
    step: 0.1,
    showSelectionBar: true,
    hidePointerLabels: true,
    translate: (value: number): string => {
      return value === 0 ? `` : `${value * 100}%`;
    },
  };
  opacity = 0.7;

  constructor(
    public AppService: AppService,
    public HsLayerManagerService: HsLayerManagerService,
    public HsEventBusService: HsEventBusService,
    public HsLayerUtilsService: HsLayerUtilsService,
    public HsLanguageService: HsLanguageService
  ) {
    this.HsEventBusService.layerManagerUpdates.subscribe(() => {
      this.layers = this.HsLayerManagerService.data.layers.filter(
        (lyr) => lyr.title != "cfd"
      );
      this.visibleLayer = this.layers.filter((lyr) => lyr.visible)[0];
      this.setOpacity(true);
    });
    this.HsEventBusService.layerAdditions.subscribe((layer) => {
      layer.visible = !layer.visible;
      setExclusive(layer.layer, true);
      this.layerSelected(layer);
    });

    this.AppService.updateLayerParams.subscribe((data) => {
      for (const layer of this.layers) {
        const olLayer: Layer<Source> = layer.layer;
        if (this.HsLayerUtilsService.isLayerWMS(olLayer)) {
          const params = this.HsLayerUtilsService.getLayerParams(olLayer);
          const layerParts = params["LAYERS"].split("_");
          if (data.year) {
            params["LAYERS"] = `${layerParts[0]}_${layerParts[1]}_${data.year}`;
          }
          if (data.location) {
            params[
              "LAYERS"
            ] = `F${data.location}_${layerParts[1]}_${layerParts[2]}`;
          }
          if (data.crop == "corn" || data.crop == "wheat") {
            if (
              ["logp", "lgp", "gdu", "hsu"].some((factor) =>
                layer.title.includes(factor)
              )
            ) {
              params["LAYERS"] = `${layerParts[0]}_${layer.title}${
                data.crop == "corn" ? 3 : 2
              }_${layerParts[2]}`;
              console.log(params["LAYERS"]);
            }
          } else if (layer.title.includes("gdu")) {
            params["LAYERS"] = `${layerParts[0]}_gdu_${layerParts[2]}`;
          }
          this.HsLayerUtilsService.updateLayerParams(olLayer, params);
        }
      }
    });
  }

  getLayerEditorState(layer: HsLayerDescriptor) {
    return layer.layer.get("editorOpened");
  }

  toggleLayerEditor(layer: HsLayerDescriptor) {
    layer.layer.set("editorOpened", !layer.layer.get("editorOpened"));
  }

  layerSelected(layer) {
    this.HsLayerManagerService.changeLayerVisibility(!layer.visible, layer);
    this.visibleLayer = layer;
    this.setOpacity(true);
  }

  setOpacity(e) {
    this.visibleLayer.layer.setOpacity(this.opacity);
  }
}
